import { render, staticRenderFns } from "./CenteredImageWrapper.vue?vue&type=template&id=749a33a3&scoped=true&"
import script from "./CenteredImageWrapper.vue?vue&type=script&lang=js&"
export * from "./CenteredImageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CenteredImageWrapper.vue?vue&type=style&index=0&id=749a33a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749a33a3",
  null
  
)

export default component.exports